const productName = (name, platform) => {
    if (!platform || platform === 'other') {
        return name;
    }

    return platform === 'agent360' || platform === 'foremost 5.0' ? name + ' (Agent360)' : name + ' (ARS)';
};

export default productName;
